import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { useTranslation } from 'react-i18next';
import { BulkAction } from '../../types';
import { useFloatingMenuHeight } from 'src/modules/contentList/components/bulkActions/hooks/useFloatingMenuHeight';
import useSelectedContent from 'src/modules/contentList/hooks/useSelectedContent';
import { Button } from 'src/shared/components/button';
import { Icon } from 'src/shared/components/icon';
import { BulkActionButtons } from './bulkActionButtons';
import { BulkActionConfirmations } from './bulkActionConfirmations';
import FloatingMenu from './floatingMenu';
import { useBulkActions } from './hooks/useBulkActions/useBulkActions';
const DEBOUNCED_TOTAL_DELAY = 500;
const BulkActionsMenu = () => {
    const { t } = useTranslation();
    const { total, modules, pages, hasPublished, hasUnpublished } = useSelectedContent();
    const payload = { modules, pages };
    const isVisible = total > 0;
    const { activeBulkAction, isPending, onCancel, onClick, onClose, onConfirm } = useBulkActions();
    const isDisabled = {
        [BulkAction.Publish]: !hasUnpublished,
        [BulkAction.Unpublish]: !hasPublished
    };
    const [debouncedTotal, setDebouncedTotal] = useState(0);
    useEffect(function preventMenuFromDisplayingZeroOnFadeOut() {
        if (debouncedTotal > 0 && total === 0) {
            setTimeout(() => setDebouncedTotal(0), DEBOUNCED_TOTAL_DELAY);
        }
        else if (debouncedTotal !== total) {
            setDebouncedTotal(total);
        }
    }, [total, debouncedTotal]);
    const { floatingMenuRef, floatingMenuHeight } = useFloatingMenuHeight();
    return (_jsxs(_Fragment, { children: [isVisible && _jsx("div", { style: { marginBottom: floatingMenuHeight } }), _jsxs(FloatingMenu, { isVisible: isVisible, ref: floatingMenuRef, children: [_jsxs("div", { className: "flex w-full flex-row-reverse items-center justify-between pl-4 md:w-auto md:flex-row md:gap-5 md:pl-0", children: [_jsx(Button, { variation: "tertiary", context: "neutral", icon: _jsx(Icon, { icon: faTimes }), "aria-label": t('module_list.bulk.close'), size: "large", onClick: onClose }), _jsx("span", { children: t('module_list.bulk.selected', { count: debouncedTotal }) })] }), _jsx(BulkActionButtons, { onClick: onClick, isPending: isPending, isDisabled: isDisabled, payload: payload })] }), _jsx(BulkActionConfirmations, { activeBulkAction: activeBulkAction, onCancel: onCancel, onConfirm: onConfirm, isPending: isPending, payload: payload })] }));
};
export default BulkActionsMenu;
